import type { PropsWithChildren } from 'react';
import {
  hasRoyaltiesAnzEnabled,
  hasRoyaltiesEnabled,
  hasRoyaltiesWorldEnabled,
} from '../utils/helpers/common';
import { RequireAddonAccess } from './RequireAddonEnabled';

/**
 * Route guards for the royalties pages: Current Member **plus** the addon the
 * page actually needs. Each mirrors the matching `canAccess*` helper in
 * `utils/helpers/common`, so nav and routes cannot disagree.
 *
 * Product intent (finalised 2026-08): Current Member is required. Workspaces
 * that are not Current Member, or lack the addon, get no nav link and
 * not-found on direct URLs. See docs/payments/terminology-and-data-mapping.md
 * (Access policy).
 */

/**
 * Historic Royalties (MSR2) — any royalties addon. Deliberately loose: a
 * member holding only `royaltiesWorld` still has MSR2 history to read.
 */
export const RequireRoyaltiesAccess = ({ children }: PropsWithChildren) => (
  <RequireAddonAccess isEnabled={hasRoyaltiesEnabled}>
    {children}
  </RequireAddonAccess>
);

/**
 * Royalties ANZ — requires `addons.anzSecondaryRoyalties`. An
 * World-only workspace must not reach a table that can only ever be
 * empty for it.
 */
export const RequireRoyaltiesAnzAccess = ({ children }: PropsWithChildren) => (
  <RequireAddonAccess isEnabled={hasRoyaltiesAnzEnabled}>
    {children}
  </RequireAddonAccess>
);

/** Royalties World — requires `addons.royaltiesWorld`. */
export const RequireRoyaltiesWorldAccess = ({
  children,
}: PropsWithChildren) => (
  <RequireAddonAccess isEnabled={hasRoyaltiesWorldEnabled}>
    {children}
  </RequireAddonAccess>
);
